// A live webcam is deliberately not enough: blocked uploads leave the camera running with
// nothing stored. Photos already on the result count too, since the photo manager is rebuilt
// empty on every page load.
export function isProctoringSatisfied({
  proctoringEnabled = false,
  proctoringDisabled = false,
  photoStored = false,
  resultHasStoredPhotos = false,
} = {}) {
  if (!proctoringEnabled || proctoringDisabled) {
    return true;
  }

  return photoStored || resultHasStoredPhotos;
}

// A reloading candidate is let straight back in by the gate above, so nothing else would
// restart their camera. The getUserMedia grant survives the reload, so this needs no click.
export function shouldResumeProctoringCapture({
  proctoringEnabled = false,
  proctoringDisabled = false,
  resultHasStoredPhotos = false,
  running = false,
} = {}) {
  if (!proctoringEnabled || proctoringDisabled || running) {
    return false;
  }

  return resultHasStoredPhotos;
}
